import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";
import { FormGroup } from "../../../../components/Form/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

/* At least one screen tall, so the fixed bar sits at the bottom (as StickyBarPage) */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - var(--app-bottom-nav-height, 0px));
`;

/* A titled block of the screen: small uppercase label + card (same as /settings) */
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  /* The card's gap already spaces the fields */
  ${FormGroup} {
    margin-bottom: 0;
  }

  .error {
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    color: var(--color-feedback-danger);
  }
`;
